import copy from 'copy-to-clipboard';
import { toast } from 'react-toastify';
import { CommunicationService } from 'corp/views/CorpProjectGroupManager/communication/communicationService';

export const handleCopyTaskIds = (taskIds: string[]) => {
  copy(taskIds.join(','));
  toast.success('Task IDs copied to clipboard');
};

export const handleBulkAudit = async (
  taskIds: string[],
  projectId?: string,
  shouldClaim?: boolean,
) => {
  const auditBatchId = await createAuditBatchForTaskIds(taskIds, projectId, shouldClaim);
  const link = getLinkForAuditBatch(auditBatchId);
  window.open(link, '_blank');
};

const getLinkForAuditBatch = (auditBatchId: string) => {
  const isRemoAdmin = window.location.pathname.includes('/remoadmin/');
  const isOutlierAdmin = window.location.pathname.includes('/outlieradmin/');
  let baseUrl = '/corp/chat_bulk_audit/';
  if (isRemoAdmin) {
    baseUrl = '/remoadmin/tools/chat_bulk_audit/';
  } else if (isOutlierAdmin) {
    baseUrl = '/expert/outlieradmin/tools/chat_bulk_audit/';
  }
  return `${baseUrl}${auditBatchId}`;
};

const createAuditBatchForTaskIds = async (
  taskIds: string[],
  projectId?: string,
  shouldClaim?: boolean,
) => {
  const objectIdsString = taskIds.join(',');
  const auditName = 'Quick Grab Bulk Audit ' + new Date().toISOString();
  const response = await CommunicationService.createChatBulkAuditBatch(
    projectId ?? '',
    objectIdsString,
    auditName,
    shouldClaim,
  );
  const auditBatchId = response.auditBatch?._id;
  if (!auditBatchId) {
    toast.error('Failed to create audit batch');
    return;
  }
  return auditBatchId;
};
